export default class DateFormattingStrategy {
    constructor(dateFormat) {
        this.dateFormat = dateFormat
    }

    formatForDateInformation(dateParameters) {
        // abstract
    }

    formatSpecifyingInformation(dateParameters) {
        // abstract
    }

    formatDate(date) {
        return this.dateFormat.formatDate(date)
    }
}



// WEBPACK FOOTER //
// ./web/js/parametersFormatting/DateFormattingStrategy.js